<template>
<div class="chapter">
<div class="inner_page">
<p class="textcenter"><a id="page_iv"></a><a id="ch00_fm03"></a><strong><span class="small">PREVIOUS WORKS BY THE AUTHOR</span></strong>:</p>
<p class="textcenter"><em>Black Mesa Poems</em></p>
<p class="textcenter1"><em>Martin &amp; Meditations on the South Valley</em></p>
<p class="textcenter1"><em>Immigrants in Our Own Land and Selected Early Poems</em></p>
<p class="textcenter1"><em>Working in the Dark: Reflections of a Poet of the Barrio</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03.vue?0f692382